import { Route, RouteComponentProps } from 'react-router-dom';

import IntroLayout from '../layout/IntroLayout/introLayout';
import { INTRO_WELCOME } from './routes';
import { IntroWelcome } from '../views/IntroWelcome/IntroWelcome';

export const IntroRoutes = (props: RouteComponentProps) => {
  return (
    <IntroLayout {...props}>
      <Route
        exact
        path={INTRO_WELCOME}
        render={() => <IntroWelcome {...props} />}
      />
    </IntroLayout>
  );
};
